"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cnbuilder = require("cnbuilder");
var _reactI18next = require("react-i18next");
var _closeCircleDefault = _interopRequireDefault(require("@teladoc/pulse/icons/close-circle-default.svg"));
var _checkCircleActive = _interopRequireDefault(require("@teladoc/pulse/icons/check-circle-active.svg"));
var _RequirementModule = _interopRequireDefault(require("./Requirement.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const Requirement = _ref => {
  let {
    className,
    testAttr,
    label,
    isValid,
    i18nValidA11yText,
    i18nInvalidA11yText
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const validityText = isValid ? i18nValidA11yText !== null && i18nValidA11yText !== void 0 ? i18nValidA11yText : t('ui:passwordCriteria.valid') : i18nInvalidA11yText !== null && i18nInvalidA11yText !== void 0 ? i18nInvalidA11yText : t('ui:passwordCriteria.invalid');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
    className: (0, _cnbuilder.cnb)(_RequirementModule.default.root, className),
    "data-test": testAttr,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      // Line below solves VoiceOver (iOS) issues (see https://dequeuniversity.com/rules/axe/html/4.3/aria-text)
      // role="text" leaving this here in case we need to revert the change below
      role: "alert",
      className: (0, _cnbuilder.cnb)(_RequirementModule.default.requirement, {
        [_RequirementModule.default.valid]: isValid
      }),
      "aria-live": "polite",
      "aria-atomic": true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _RequirementModule.default.icon,
        children: isValid ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkCircleActive.default, {
          className: _RequirementModule.default.check
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeCircleDefault.default, {
          className: _RequirementModule.default['close-circle']
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "visually-hidden",
        children: "".concat(validityText, ": ")
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: label
      })]
    })
  });
};
var _default = exports.default = Requirement;